import script from "./sr-upload-plus.vue?vue&type=script&setup=true&lang=js"
export * from "./sr-upload-plus.vue?vue&type=script&setup=true&lang=js"

import "./sr-upload-plus.vue?vue&type=style&index=0&id=0850cfbe&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0850cfbe"]])

export default __exports__